import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from './select-next';

const homeOwnershipOptions = [
  {
    name: 'Own',
    key: 'own'
  },
  {
    name: 'Rent',
    key: 'rent'
  }
];

const HomeOwnershipStatusSelect = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseSelect
      name="homeOwnerStatus"
      label="Home Ownership Status"
      options={homeOwnershipOptions}
      transparent
      disabledStateValue={{ value: '', label: 'Home Ownership Status' }}
      data-cv-test="homeOwnerStatus"
      {...props}
      data-cv-test-override={dataCvTest || 'homeOwnerStatus'}
    />
  );
};

HomeOwnershipStatusSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

HomeOwnershipStatusSelect.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default HomeOwnershipStatusSelect;
